import { Customer, CustomerStatus } from '../data';

export const isManualReview = (customer: Customer) => customer.customerStatus === CustomerStatus.ManualReview;

export const isDenied = (customer: Customer) => customer.customerStatus === CustomerStatus.Denied;

export const isVerified = (customer: Customer) => customer.customerStatus === CustomerStatus.Verified;

export const isInititated = (customer: Customer) => customer.customerStatus === CustomerStatus.Initiated;

export const isExpired = (customer: Customer) => customer.customerStatus === CustomerStatus.Expired;

export const isSignedUp = (customer: Customer) => isVerified(customer) && !!customer.account && !!customer.card;

export const canSignUp = (customer: Customer) => isInititated(customer) || isExpired(customer);

export const hasMaxAccounts = (customer: Customer) => customer.accounts?.length >= 2;

export const spendingAccountName = (customer: Customer) =>
  customer.accounts.find(a => a.id === customer.card.spendingAccountId)?.name;
